export default __webpack_public_path__ + "static/Minigun_Turret-0ad1580c3ca7a1a2e59075b29e216e60.png";